module.exports = __webpack_public_path__ + "static/media/IMG_7104.41e01f8a.jpg";